import PropTypes from 'prop-types';
import React from 'react';
import FormattedTranslation from '@htmniseko/htm-ui/Intl/FormattedTranslationMui';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Typography, Link } from '@material-ui/core';
import FaEmailIcon from '../../Icons/FaEmailOutlined';
import FaPhoneIcon from '../../Icons/FaPhone';

const useStyles = makeStyles(theme => ({
  email: {
    // TODO: Setting the h4 variant to the Link component should work but it's not, it looks like a MUI issue.
    fontFamily: theme.custom.romanFontFamily,
    fontSize: theme.typography.pxToRem(20),
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.pxToRem(19),
    },
  },
  icon: {
    color: theme.palette.appBar.main,
    margin: '0 6px',
    marginTop: theme.typography.pxToRem(3),
  },
  phone: {
    color: theme.palette.appBar.main,
    display: 'inline',
    fontFamily: theme.custom.romanFontFamily,
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.pxToRem(19),
    },
  },
}));

const Content = ({ email, isMobile }) => {
  const classes = useStyles();
  const justify = isMobile ? 'center' : 'flex-end';
  const spacing = isMobile ? 0 : 4;
  return (
    <Grid container direction="row" alignItems="center" justifyContent={justify} spacing={spacing}>
      <Grid item>
        <FaEmailIcon className={classes.icon} fontSize="small" />
        <Link className={classes.email} href={`mailto:${email}`}>
          {email}
        </Link>
      </Grid>
      <Grid item>
        <FaPhoneIcon className={classes.icon} fontSize="small" viewBox="0 0 32 32" />
        <Typography className={classes.phone} variant="h4" gutterBottom>
          <FormattedTranslation id="kiniseko.tel" />
        </Typography>
      </Grid>
    </Grid>
  );
};

Content.propTypes = {
  email: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
};

Content.defaultProps = {
  isMobile: false,
};

export default Content;
